import { BreadcrumbItem } from "common/components/breadcrumb/Breadcrumb";
import { TallLayout } from "common/components/layouts/TallLayout";
import { H1 } from "common/components/Typography";
import React from "react";
import { ContentBreadcrumbFragment_context } from "__generated__/types";

interface Props {
  breadcrumbItems?: BreadcrumbItem[];
  title?: string;
  context?: ContentBreadcrumbFragment_context[];
}

export const KurssloeyfeLayout: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  children,
  context = [],
}) => {
  return (
    <TallLayout context={context}>
      {title && <H1>{title}</H1>}
      <div>{children}</div>
    </TallLayout>
  );
};
